import styles from './Projects.module.scss';
import { projects } from '../../data/resume';

export function Projects() {
  return (
    <section className="section container" id="projects" aria-label="Projects">
      <h2 className="sectionTitle">Projects</h2>
      <div className={styles.grid}>
        {projects.map(p => (
          <article key={p.name} className={styles.card}>
            <div className={styles.name}>{p.name}</div>
            <div className={styles.desc}>{p.description}</div>
            <div className={styles.tags}>
              {p.tech.map(t => <span key={t} className="badge">{t}</span>)}
            </div>
            <div className={styles.links}>
              {p.link ? <a className={styles.link} href={p.link} target="_blank" rel="noreferrer">Live</a> : null}
              {p.repo ? <a className={styles.link} href={p.repo} target="_blank" rel="noreferrer">Code</a> : null}
            </div>
          </article>
        ))}
      </div>
    </section>
  );
}